import BaseService from './BaseService';
import entities from 'src/config/entities';
import FileService from 'src/services/FileService'
class CandidateService extends BaseService{

  constructor() {
    super({ entity: entities.CANDIDATE });
  }

  async downloadGDPRData(id, fileName = 'data') {
    try {
      let { data } = await this.instance.get(`/${id}/gdpr`)
      let blob = new Blob([JSON.stringify(data, null, 2)], {type : 'application/json'});
      FileService.downloadFileInBrowser(blob, `${fileName}.json`)
    } catch (e) {
      this._handleError({ translationKey: 'candidates.messages.downloadGDPRError', error: e });
      throw e;
    }
  }

}

export default new CandidateService();
